@if (!chatReady()) {
  <div class="flex-1 flex justify-center">
    <mai-chatia-waiting></mai-chatia-waiting>
  </div>
} @else if (messages().length === 0) {
  <mai-chat-empty-screen
    class="flex-1 flex justify-center w-full self-stretch"></mai-chat-empty-screen>
} @else {
  <div class="max-w-192 w-full flex flex-1 flex-col min-h-0 text-sm">
    <main
      #messageContainer
      [maiScrollPosition]="'chat:' + service.chatId()"
      class="flex-1 p-6 not-expanded:p-4 not-expanded:pt-0 mib-scrollbar flex flex-col gap-4 overflow-y-auto min-h-0"
      (scroll)="onScroll()">
      @for (message of messages(); track message.id) {
        <div
          class="flex flex-col gap-px"
          [class.items-end]="message.role === MessageRole.User"
          [class.text-right]="message.role === MessageRole.User">
          <div
            class="markdown-message w-fit rounded-l-mib rounded-br-mib rounded-tr-mib"
            [class.p-4]="message.role === MessageRole.User"
            [class.bg-mib-branding-800]="message.role === MessageRole.User"
            [innerHTML]="message.content | markdown"
            (click)="handleClick($event)"></div>

          @if (!$last || !chatLocked()) {
            <button
              mibButton
              type="button"
              #tooltipDir="mibTooltip"
              [class.float-right]="message.role === MessageRole.User"
              mode="flat"
              theme="ai"
              [size]="copyButtonSize()"
              [mibTooltip]="copyTooltip()"
              mibTooltipKeepOpen
              mibTooltipShowDelay="500"
              (click)="copyMessage(message, tooltipDir)">
              <svg mib-icon name="copy"></svg>
            </button>
          }
        </div>
      }

      @if (isThinking()) {
        <mib-dots-loader size="sm" color="light" label="Preparing the answer"></mib-dots-loader>
      }
    </main>

    <div
      class="shrink-0 p-4 border-mib-branding-500 not-height-medium:p-2"
      [class.border-t]="isOverflowing() || hitlMessage()">
      @if (!isThinking() && hitlMessage()) {
        <div class="flex flex-col gap-3 pb-6">
          Should I proceed with the generation of the video edit following this plan?
          <button mibButton type="button" theme="ai" (click)="sendHitlAnswer(true)">
            Yes, I approve this plan
          </button>
          <!-- <button mibButton type="button" theme="ai" (click)="sendHitlAnswer(false)"
                >No, I reject this plan</button
              > -->
          <span class="text-xs">
            If you want to improve this plan, please provide further informations in the field
            below.
          </span>
        </div>
      }

      <mai-prompt-box [displayPlusButton]="promptExamples().length > 0"></mai-prompt-box>
    </div>
  </div>
}
